import Card from "./Card";

export default function LoadingState({ title = "Loading", message = "The Empress is checking the vibe." }) {
  return (
    <Card className="mx-auto max-w-2xl p-6">
      <div className="flex items-center gap-4">
        <span className="h-10 w-10 rounded-full border-2 border-hookd-empress border-t-transparent motion-safe:animate-spin" />
        <div>
          <h2 className="font-display text-2xl font-bold text-hookd-cream">{title}</h2>
          <p className="text-sm text-hookd-muted">{message}</p>
        </div>
      </div>
    </Card>
  );
}
